const summary = [
  {
    points: [
        "Experienced Technical Manager with over 15+ years, driving Java/J2EE development, software architecture, and enterprise-scale project delivery.",
        "Proven leader of cross-functional teams building scalable, cloud-native solutions on AWS and Azure — consistently aligning technology strategy with business objectives.",
        "Deep expertise in Java, Spring Boot, Microservices, and ReactJS, with hands-on delivery across complex, high-availability production systems.",
        "Multi-cloud certified professional (Microsoft Azure, Oracle Cloud, AWS) with a growing specialization in Generative AI — certified in Anthropic Claude, Databricks Gen AI, and Oracle OCI AI.",
        "Champion of Agile and DevOps — designing CI/CD pipelines and automation frameworks that measurably accelerate time-to-market and engineering velocity.",
        "Trusted communicator and technical bridge: translating complex engineering decisions into business outcomes for senior stakeholders and C-suite leaders.",
        "Recognized mentor and engineering excellence driver — building high-performing teams, raising engineering standards, and delivering production-ready solutions at scale."
    ]
  }
];

export {summary};